import { useEffect } from "react";
import { Hero } from "@/components/sections/Hero";
import { Marketplaces } from "@/components/sections/Marketplaces";
import { Features } from "@/components/sections/Features";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { PricingTeaser } from "@/components/sections/PricingTeaser";
import { FAQ } from "@/components/sections/FAQ";
import { FinalCTA } from "@/components/sections/FinalCTA";

export default function Home() {
  useEffect(() => {
    document.title = "MACHA — The AI copilot for freelancers";
  }, []);

  return (
    <>
      <Hero />
      <Marketplaces />
      <Features />
      <HowItWorks />
      <PricingTeaser />
      <FAQ />
      <FinalCTA />
    </>
  );
}
